var React = require('react');

function IconMailInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M4.274,8.663l10.034,7.948c0.455,0.36,1.082,0.52,1.691,0.49c0.609,0.029,1.236-0.13,1.691-0.49   l10.034-7.948c0.802-0.634,0.62-1.152-0.4-1.152H16H4.675C3.654,7.511,3.473,8.029,4.274,8.663z","key":0}),React.createElement("path",{"d":"M28.448,10.76l-10.965,8.324c-0.41,0.309-0.947,0.459-1.483,0.453c-0.536,0.006-1.073-0.145-1.483-0.453   L3.552,10.76c-0.814-0.617-1.48-0.286-1.48,0.735v13.659c0,1.021,0.836,1.856,1.857,1.856H16h12.071   c1.021,0,1.857-0.836,1.857-1.856V11.495C29.929,10.474,29.263,10.143,28.448,10.76z","key":1})]));
}

IconMailInline.defaultProps = {"enableBackground":"new 0 0 32 32","height":"32px","version":"1.1","viewBox":"0 0 32 32","width":"32px","xmlSpace":"preserve"};

module.exports = IconMailInline;

IconMailInline.default = IconMailInline;
